import { useQuery } from '@tanstack/react-query';
import { createSitesApi } from '@features/sites/api/sites.api';
import { auth } from '@core/utils/firebase/firebase';
import type { Auth } from '@angular/fire/auth';
import type { Site } from '@core/interfaces/api';

const sitesApi = createSitesApi(auth as Auth);

export function useOrgSites(
  organizationId: number | undefined,
  options?: { enabled?: boolean },
) {
  return useQuery<Site[]>({
    queryKey: ['orgSites', organizationId],
    queryFn: async () => {
      if (!organizationId) throw new Error('organizationId is required');
      return sitesApi.getSitesByOrgId(String(organizationId));
    },
    enabled: Boolean(organizationId) && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  });
}

